export const GOAL_TYPE_DEFINITIONS = [
  { type: 'PASTAS_GERADAS', label: 'Pastas geradas' },
  { type: 'PASTAS_APROVADAS', label: 'Pastas aprovadas' },
  { type: 'VISITAS_AGENDADAS', label: 'Visitas agendadas' },
] as const;

export type GoalType = (typeof GOAL_TYPE_DEFINITIONS)[number]['type'];

export interface UserGoal {
  competency: string;
  goal: number;
  type: GoalType;
}

export interface CompetencyGoalType {
  enabled: boolean;
  label: string;
  type: GoalType;
}

export interface TeamGoal {
  goal: number;
  type: GoalType;
}

export interface GoalsCompetency {
  period: string;
  working_days: number;
}

export interface GoalsCompetencyConfiguration {
  competency: GoalsCompetency;
  goal_types: CompetencyGoalType[];
  team_goals: TeamGoal[];
}
